import { useState } from "react";
import { ShieldCheck, Phone, Zap, Clock, Trash2 } from "lucide-react";
import { DeletedUserBadge } from "@/components/DeletedUserBadge";

const ROLE_LABEL = { admin: "Admin", supervisor: "Supervisor", vigilador: "Vigilador" };

export function GuardOnDutyPanel({ guards, canManage, onDelete, isMobile }) {
  const [showPhone, setShowPhone] = useState(null);

  return (
    <div style={{ background: "#0A0A0A", color: "#FFFBF4", borderRadius: 12, padding: 18, marginBottom: 18, borderLeft: "4px solid #16a34a" }} data-testid="on-duty-panel">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <ShieldCheck size={18} color="#16a34a" />
        <span style={{ fontSize: 12, fontWeight: 900, letterSpacing: "0.12em", textTransform: "uppercase" }}>De guardia ahora</span>
        <span style={{ marginLeft: "auto", background: "#16a34a", color: "#fff", borderRadius: 10, padding: "1px 9px", fontSize: 11, fontWeight: 800 }} data-testid="on-duty-count">{guards.length}</span>
      </div>
      {guards.length === 0 && <div style={{ fontSize: 13, color: "rgba(255,251,244,0.6)" }} data-testid="on-duty-empty">Nadie de retén en este momento.</div>}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fill, minmax(260px, 1fr))", gap: 10 }}>
        {guards.map((g) => (
          <div key={g.id} style={{ background: "rgba(255,251,244,0.06)", borderRadius: 10, padding: 14 }} data-testid={`on-duty-${g.id}`}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ background: "#16a34a", color: "#fff", borderRadius: "50%", width: 22, height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 900 }}>{g.priority}</span>
              <span style={{ fontWeight: 900, fontSize: 15 }}>{g.user_name}</span>
              {g.user_deleted && <DeletedUserBadge id={g.id} />}
              <span style={{ fontSize: 10, color: "rgba(255,251,244,0.5)", fontWeight: 700 }}>{ROLE_LABEL[g.user_role] || g.user_role}</span>
              {canManage && onDelete && (
                <button onClick={() => onDelete(g.id)} style={{ marginLeft: "auto", border: "none", background: "transparent", color: "rgba(255,251,244,0.6)", cursor: "pointer" }} data-testid={`on-duty-delete-${g.id}`}>
                  <Trash2 size={15} />
                </button>
              )}
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,251,244,0.6)", margin: "6px 0 10px", display: "flex", alignItems: "center", gap: 5 }}>
              <Clock size={11} /> {g.time_from && g.time_to ? `${g.time_from}–${g.time_to}` : "Todo el día"}
            </div>
            {g.contact_phone ? (
              showPhone === g.id ? (
                <a href={`tel:${g.contact_phone.replace(/\s/g, "")}`} className="btn-primary" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "9px 12px", borderRadius: 8, textDecoration: "none", fontSize: 13 }} data-testid={`call-${g.id}`}>
                  <Phone size={14} /> {g.contact_phone}
                </a>
              ) : (
                <button onClick={() => setShowPhone(g.id)} style={{ width: "100%", background: "#BF3437", color: "#fff", border: "none", borderRadius: 8, padding: "9px 12px", fontWeight: 800, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }} data-testid={`activate-${g.id}`}>
                  <Zap size={14} /> Activar relevo
                </button>
              )
            ) : (
              <div style={{ fontSize: 11, color: "rgba(255,251,244,0.4)" }}>Sin teléfono cargado</div>
            )}
            {g.note && <div style={{ fontSize: 11, color: "rgba(255,251,244,0.6)", marginTop: 8, fontStyle: "italic" }}>{g.note}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
